import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarningFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	width: 20,
	height: 20,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M512 128L64 896c-12 20 2 48 26 48h844c24 0 38-28 26-48L512 128z",
			fill: "#faad14"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 472,
			y: 360,
			width: 80,
			height: 260,
			rx: 40,
			fill: "#000000"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 512,
			cy: 720,
			r: 40,
			fill: "#000000"
		})
	]
});
export default SvgWarningFilled;
